import { FormLayout } from "@careinfo/layout";
import { tw } from "@careinfo/tailwind";
import React from "react";

import { useForm } from "react-hook-form";
import ComboboxInput from "../reusable/ComboboxInput";
import APIS from "../../constant/Endpoint";
import TextField from "../reusable/TextInput";
import NumberField from "../reusable/NumberField";

const CreateRemoteCharge = (props: any) => {
  const { handleCreate, isLoading } = props;
  const {
    handleSubmit,
    setError,
    register,
    setValue,
    getValues,
    clearErrors,
    formState: { errors },
  } = useForm({});
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <div className={tw`grid grid-cols-2 gap-x-4`}>
        <ComboboxInput
          url={APIS.LOCATION_LIST}
          props={{ level: 0, is_active: true }}
          queryKey={"country"}
          register={register("origin", {
            required: "Origin Country is required",
          })}
          errors={errors?.origin}
          name={"origin"}
          label={"Origin Country"}
          setValue={setValue}
          placeholder={"Search Country"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          url={APIS.LOCATION_LIST}
          props={{ level: 0, is_active: true }}
          queryKey={"country"}
          register={register("destination", {
            required: "Destination Country is required",
          })}
          errors={errors?.destination}
          name={"destination"}
          label={"Destination Country"}
          setValue={setValue}
          placeholder={"Search Country"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <TextField
          label={"Postal Code"}
          register={register("zip_code", {
            required: "Postal Code is required",
          })}
          errors={errors.zip_code}
        />
        <NumberField
          placeholder={"Enter amount"}
          value={getValues("amount")}
          register={register("amount", { required: "Amount is required" })}
          errors={errors?.amount}
          label={"Amount"}
          setValue={setValue}
          clearErrors={clearErrors}
        />
      </div>
    </FormLayout>
  );
};

export default CreateRemoteCharge;
